w2p.controller('CompanySettingsCtrl', function($scope,$http, Notification) {



});